import Lottie from "react-lottie";
import "../styles.css";
import WatchDogsAnimation from "../resources/Animations/WD.json";

const BootAnimationBackdrop = () => {
  const bootAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: WatchDogsAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="backdrop-animation">
      <div className="animation-container">
        <Lottie options={bootAnimationOptions} />
      </div>
    </div>
  );
};

export default BootAnimationBackdrop;
